"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _basic = _interopRequireDefault(require("./_basic"));
class NotificationsApi extends _basic.default {
  /**
   * Represents a Notifications Api.
   * @constructor
   * @param {Function} param0.userTokenFactory Function that returns access token
   * @param {String} param0.notificationsApiUrl Url of api
   * @param {Function} param0.accountIdFactory Optional. Function that returns accountId for cross account requests
   * @param {Number} param0.timeout Optional. Request timeout in ms
   * @param {accountId} param0.accountId Optional. AccountId for cross account requests
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      notificationsApiUrl,
      accountIdFactory,
      timeout,
      accountId
    } = _ref;
    super({
      userTokenFactory,
      accountIdFactory,
      timeout,
      baseURL: notificationsApiUrl,
      accountId
    });
  }

  /**
   * 
   * @param {String} param0.dateCreated Optional. Date of notification. 2022-01-01 
   * @param {String} param0.limit Optional. Limit response size 
   * @param {String} param0.offset Optional. Skip first n records
   * @returns {Array} [{id, data}]
   */
  async list() {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._callApi({
      url: '/user',
      params
    });
  }

  /**
   * @description mark all notifications read
   */
  async markSeen() {
    return this._callApi({
      url: `/user`,
      method: 'post'
    });
  }

  /**
   * 
   * @param {Object} data {type, data} Create user notification 
   */
  async createUserNotification(data) {
    return this._callApi({
      url: `/user`,
      method: 'put',
      data
    });
  }

  /**
   * @param {Object} data {type, data} Create user notification 
   */
  async SACreateNotification(data) {
    return this._callApi({
      url: `/service`,
      method: 'put',
      data
    });
  }

  /**
   * 
   * @param {String} param0.id id of notification 
   * @param {String} param0.accountId accountId of notification 
   * @param {String} param0.userId userId of notification 
   * @param {String} param0.dateCreated dateCreated of notification 
   * @param {String} param0.type type of notification 
   * @param {String} param0.seen seen of notification 
   * @param {String} param0.limit limit response size
   * @param {String} param0.offset skip first n records
   * @param {String} param0.parentId parentId of notification 
   * 
   * @returns {Array} [{id, accountId,userId, dateCreated, type, seen, limit, offset, parentId, data}]
   */

  async SAListNotifications(_ref2) {
    let {
      id,
      accountId,
      userId,
      dateCreated,
      type,
      seen,
      limit,
      offset,
      parentId
    } = _ref2;
    return this._callApi({
      url: '/service',
      params: {
        id,
        accountId,
        userId,
        dateCreated,
        type,
        seen,
        limit,
        offset,
        parentId
      }
    });
  }

  /**
   * 
   * @param {String} id id of notification 
   * @param {String} param0.accountId accountId of notification 
   * @param {String} param0.userId userId of notification 
   * @param {String} param0.dateCreated dateCreated of notification 
   * @param {String} param0.type type of notification 
   * @param {String} param0.seen seen of notification 
   * @param {String} param0.parentId parentId of notification 
   */

  async SAUpdateNotification(id, params) {
    return this._callApi({
      url: `/service/${id}`,
      method: 'post',
      params
    });
  }

  /**
   * 
   * @param {String} id id of notification to delete 
   */

  async SADeleteNotification(id) {
    return this._callApi({
      url: `/service/${id}`,
      method: 'delete'
    });
  }

  /**
   * 
   * @param {Object} param0.data Event data 
   * @param {String} param0.service Service name
   */
  async createTrailEvent(_ref3) {
    let {
      data,
      service
    } = _ref3;
    return this._callApi({
      url: `/trail/${service}`,
      method: 'put',
      data
    });
  }

  /**
   * 
   * @param {String} param0.dateCreated Optional. Date of notification. 2022-01-01 
   * @param {String} param0.limit Optional. Limit response size 
   * @param {String} param0.offset Optional. Skip first n records
   * @param {Service} param0.service Service name
   * @returns {Array} [{id, data}]
   */
  async listTrailEvents(params) {
    return this._callApi({
      url: '/trail',
      params
    });
  }
}
exports.default = NotificationsApi;